import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, unref as _unref, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/questionnaire/questionnaire.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-eee86218")

_pushScopeId("data-v-eee86218")
const _hoisted_1 = { class: "health-questionnaire" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", null, [
  /*#__PURE__*/_createVNode("img", {
    class: "header-top-banner",
    src: _imports_0
  })
], -1)
const _hoisted_3 = { class: "health-questionnaire__body" }
const _hoisted_4 = /*#__PURE__*/_createVNode("h1", { class: "health-questionnaire__header-title" }, "健康问卷", -1)
const _hoisted_5 = { class: "health-questionnaire-list" }
const _hoisted_6 = { class: "questionnaire-list" }
const _hoisted_7 = { class: "health-questionnaire-list__item" }
const _hoisted_8 = { class: "list-item__title" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" 上传舌苔或其他资料 ")
const _hoisted_10 = { class: "list-item__body" }
const _hoisted_11 = /*#__PURE__*/_createVNode("p", { style: {"color":"#555555","font-size":"14px"} }, "* 尽量请别人帮助拍摄，不要使用自拍或美颜", -1)
const _hoisted_12 = { class: "health-questionnaire-list__item" }
const _hoisted_13 = /*#__PURE__*/_createVNode("div", { class: "list-item__title" }, "其他", -1)
const _hoisted_14 = { class: "list-item__body van-hairline--surround" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode("提交")
const _hoisted_16 = { style: {"overflow":"hidden"} }
const _hoisted_17 = /*#__PURE__*/_createVNode("span", { style: {"font-size":"20px","line-height":"40px"} }, "舌苔拍照示例", -1)
const _hoisted_18 = { style: {"padding":"10px","text-align":"left"} }
const _hoisted_19 = { style: {"margin-top":"15px"} }
const _hoisted_20 = { style: {"text-align":"center"} }
const _hoisted_21 = /*#__PURE__*/_createVNode("main", { class: "popup-body__main" }, [
  /*#__PURE__*/_createVNode("span", null, "注意事项："),
  /*#__PURE__*/_createVNode("ol", { style: {"margin-left":"15px"} }, [
    /*#__PURE__*/_createVNode("li", null, [
      /*#__PURE__*/_createVNode("p", null, "在拍照前，不要吃东西或者漱口，会导致舌质和舌苔发生改变；")
    ]),
    /*#__PURE__*/_createVNode("li", null, [
      /*#__PURE__*/_createVNode("p", null, "不要让舌苔染上颜色，注意不要牙刷把厚苔刮掉，会影响判断；")
    ]),
    /*#__PURE__*/_createVNode("li", null, [
      /*#__PURE__*/_createVNode("p", null, "尽量在光线充足（比如窗边、阳台、室外，不要背光）的地方使用后置摄像头拍摄，不要开任何美颜、滤镜，这样识别舌苔的准确率会更高。")
    ])
  ])
], -1)
const _hoisted_22 = { class: "popup-body__footer" }
const _hoisted_23 = /*#__PURE__*/_createTextVNode("知道了，去拍照")
_popScopeId()

import { ref, onMounted, reactive, computed } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { Dialog } from 'vant';
import wx from 'wx';
import debounce  from 'lodash/debounce'

import SimpleSheTaiImage from '@/assets/img/healthQuestionnaire/sample_she-tai.png'

import { findHealthQuestionList, findHealthQuestionListById, saveHealthQuestion, getMemberHealthQuestion } from '@/api/MemberHealthQuestion'
import { Toast } from 'vant';
import { uploadImage } from '@/api/uploadFile'


export default _defineComponent({
  expose: [],
  setup(__props) {


const showPopup = ref(false)
const popupBoxShadom = ref(false)
const sheTaiPopupScrollCssStyle = debounce(function(e){
    console.log("sheTaiPopupScrollCssStyle", e);

    let scrollDom = e.target

    // 百分值
    const threshold = 2;

    if( scrollDom.scrollTop / (scrollDom.scrollHeight - scrollDom.clientHeight) * 100 >= threshold ){
        // 满足阈值，则进行css的设置。
        popupBoxShadom.value = true
    }else{
        popupBoxShadom.value = false
    }
    
}, 50, {
    leading: true,
    maxWait: 200,
    trailing: true,
})


const data = reactive({
    question: [],
    resourceImages: [],
    otherInfo: '',
    memberId: null,
    // 问卷主键ID
    id: null,
})

// 表单只读
const formIsRead = ref(false)
// 表单禁用
const FormIsDisabled = ref(false)

const getResourceImages = ref([])


/*
 备注：仅能click触发，函数内部涉及到更改可选项，所以，不能绑定onchange事件。
 */
function handlerChangeByQuestionItem(dataItem){
    console.log("handlerChangeByQuestionItem", dataItem);
    
    const selectedItems = dataItem.selectedItems
    const selectItems = dataItem.selectItems
    const normalAnswerItems = dataItem.normalAnswerItems
    const questionItems = dataItem.questionItems

    if(selectedItems.length > 0){

        // 根据最后一个选中的选项，决定是保留正常项还是异常项
        const lastSelectedItem = selectedItems[selectedItems.length - 1]

        console.log("old selectedItems", dataItem['selectedItems']);
        
        // 最后一次选中的项将决定保留正常还是非正常
        if(normalAnswerItems.includes(lastSelectedItem)){
            dataItem['selectedItems'] = normalAnswerItems.filter(item => selectedItems.includes(item))
        }else if(questionItems.includes(lastSelectedItem)){
            dataItem['selectedItems'] = questionItems.filter(item => selectedItems.includes(item))
        }
        
        console.log("new selectedItems", dataItem['selectedItems']);
    }

}


function reourceImageOversize(file) {
    console.log(file);
    Toast('图片大小不能超过20MB');
}

function uploadResourceImage(fileInfo, detail){
    console.log("uploadResourceImage", fileInfo, detail);
    fileInfo.status = "uploading"
    fileInfo.message = "上传中..."
    uploadImage('HealthQuestion', fileInfo.file).then(imgPath => {
        console.log("uploadResourceImage", imgPath)
        fileInfo.uploadPath = imgPath
        Toast.success('上传成功');
        fileInfo.status = ""
        fileInfo.message = ""
    }).catch(e => {
        Toast.fail('上传失败');
        fileInfo.status = "failed"
        fileInfo.message = "上传失败"
    });
}


function switchHealthPage(){
    wx.miniProgram.switchTab({
        url: '/pages/health/health',
    });
}


function save(){
    
    /**
     * 实际保存的逻辑
     */
    const doSave = () => {
    
        data.resourceImages = getResourceImages.value.map(v=>{
            if('uploadPath' in v){
                return v.uploadPath
            }else{
                return v.url
            }
        }).filter(v=>v)
    
        console.debug("save ==> data.resourceImages", data.resourceImages, getResourceImages.value)
    
        const formData = {
            id: null,
            otherInfo: data.otherInfo,
            memberId: data.memberId,
            resourceImages: data.resourceImages.filter(v=>v).join(','),
            questionInfoList: data.question.content.filter(item => item.selectedItems.length > 0).map(item => {
                return {
                    id: item.id,
                    name: item.questionName,
                    selectedItems: JSON.stringify(item.selectedItems),
                }
            })
        }
    
        console.log("save fomrData", formData);
        
        saveHealthQuestion(formData).then(respData => {
            console.log("saveHealthQuestion", respData);
            Toast.success({
                message: "保存成功",
                overlay: true,
                forbidClick: true,
                onClose(){
                    switchHealthPage()
                },
            })
            
        }).catch(err => {
            Toast.success("保存失败")
        })
    }


    /*
        检测的代码
    */
    if(getResourceImages.value.some(v=>v.status === "uploading")){
        Toast("图片正在上传中，请稍后重新保存")
        return;
    }

    if(getResourceImages.value.some(v=>v.status === "failed")){
        Dialog.confirm({
            title: '警告',
            message: '检测到存在图片上传失败，是否继续保存？',
            confirmButtonText: '继续保存',
        })
        .then(() => {
            // on confirm
            doSave();
        })
        .catch(() => {
            // on cancel
        });
    }else{
        doSave();
    }

}

onMounted(async ()=>{

    // 加载数据得模式： view查看模式
    const mode = useRoute().query.mode

    let resultDataHandlePromise = null;

    // 选中的Promise，待解析的处理
    let resolveSelectedItemPromise = null;
    if('view' === mode){
        // view查看模式
        const id: number = Number(useRoute().query.id as string) as number
        await getMemberHealthQuestion(id).then(respData => {
            respData._reportIds = respData.reportIds.split(',').filter(v=>v)
            respData._selectedItemJson = respData.selectedItemJson && JSON.parse(respData.selectedItemJson) || {}

            resolveSelectedItemPromise = Promise.resolve(respData._selectedItemJson)

            data.resourceImages = respData.resourceImages.split(',').filter(v=>v)
            getResourceImages.value = data.resourceImages.map(img => {
                return {
                    url : img
                }
            })

            data.otherInfo = respData.otherInfo

            data.memberId = respData.memberId
        })

        resultDataHandlePromise = findHealthQuestionListById(id)

        // 按钮设置为禁用并且只读
        formIsRead.value = true;
        FormIsDisabled.value = true;

        console.log("进入【查看】模式");
        
    }else{

        const memberId = useRoute().query.memberId
        if(!memberId){
            Dialog.alert({
                title: '错误',
                message: '未传递有效成员标识',
            }).then(() => {
            // on close
            });
            return;
        }
        data.memberId = memberId;

        resultDataHandlePromise = findHealthQuestionList(data.memberId)
        
        console.log("进入【新增|编辑】模式");

    }


    resultDataHandlePromise.then(respData => {
        console.log("findHealthQuestionList", respData);

        respData.content.forEach(item => {

            // 处理并定义参数
            // 全部可选的参数
            item.selectItems = item.options?.split("\n").map((v: string) => v.trim()).filter(v => v) || []
            // 正常的项
            item.normalAnswerItems = item.normalAnswers?.split(",").map((v: string) => v.trim()).filter(v => v) || []
            // 异常的项
            item.questionItems = item.selectItems.filter(selectItem => !item.normalAnswerItems.includes(selectItem))

            if(resolveSelectedItemPromise){
                // 解析选中项得信息
                resolveSelectedItemPromise.then(json => {
                    if(item.id in json){
                        item.selectedItems = json[item.id]
                    }else{
                        // 给默认值，空数组。
                        item.selectedItems = []
                    }
                })

            }else{
                // 选中的项
                item.selectedItems = []
            }

        })

        data.question = respData
    });


})



return /*#__PURE__*/_withId((_ctx: any,_cache: any) => {
  const _component_van_divider = _resolveComponent("van-divider")
  const _component_van_button = _resolveComponent("van-button")
  const _component_van_checkbox = _resolveComponent("van-checkbox")
  const _component_van_checkbox_group = _resolveComponent("van-checkbox-group")
  const _component_van_uploader = _resolveComponent("van-uploader")
  const _component_van_field = _resolveComponent("van-field")
  const _component_van_col = _resolveComponent("van-col")
  const _component_van_row = _resolveComponent("van-row")
  const _component_van_cell_group = _resolveComponent("van-cell-group")
  const _component_van_form = _resolveComponent("van-form")
  const _component_van_icon = _resolveComponent("van-icon")
  const _component_van_image = _resolveComponent("van-image")
  const _component_van_popup = _resolveComponent("van-popup")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      _createVNode(_component_van_form, {
        readonly: formIsRead.value || FormIsDisabled.value
      }, {
        default: _withId(() => [
          _createVNode(_component_van_cell_group, { inset: "" }, {
            default: _withId(() => [
              _hoisted_4,
              _createVNode(_component_van_divider),
              _createVNode("div", _hoisted_5, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(data.question.content, (item, index) => {
                  return (_openBlock(), _createBlock("div", {
                    class: "health-questionnaire-list__item",
                    key: index
                  }, [
                    _createVNode("div", {
                      class: "list-item__title",
                      textContent: _toDisplayString(item.questionName)
                    }, null, 8, ["textContent"]),
                    _createVNode("div", _hoisted_6, [
                      _createVNode(_component_van_checkbox_group, {
                        disabled: FormIsDisabled.value,
                        modelValue: item.selectedItems,
                        "onUpdate:modelValue": ($event: any) => (item.selectedItems = $event),
                        direction: "horizontal",
                        "checked-color": "#4850c4"
                      }, {
                        default: _withId(() => [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(item.selectItems, (selectItem, selectIndex) => {
                            return (_openBlock(), _createBlock(_component_van_checkbox, {
                              key: selectIndex,
                              name: selectItem,
                              shape: "square",
                              onClick: ($event: any) => (handlerChangeByQuestionItem(item))
                            }, {
                              icon: _withId(({checked}) => [
                                checked
                                  ? (_openBlock(), _createBlock(_component_van_button, {
                                      key: 0,
                                      size: "small",
                                      round: "",
                                      color: "#7232dd"
                                    }, {
                                      default: _withId(() => [
                                        _createTextVNode(_toDisplayString(selectItem), 1)
                                      ]),
                                      _: 2
                                    }, 1024))
                                  : (_openBlock(), _createBlock(_component_van_button, {
                                      key: 1,
                                      size: "small",
                                      plain: "",
                                      round: "",
                                      color: "#7232dd"
                                    }, {
                                      default: _withId(() => [
                                        _createTextVNode(_toDisplayString(selectItem), 1)
                                      ]),
                                      _: 2
                                    }, 1024))
                              ]),
                              _: 2
                            }, 1032, ["name", "onClick"]))
                          }), 128))
                        ]),
                        _: 2
                      }, 1032, ["disabled", "modelValue", "onUpdate:modelValue"])
                    ])
                  ]))
                }), 128)),
                _createVNode("div", _hoisted_7, [
                  _createVNode("div", _hoisted_8, [
                    _hoisted_9,
                    _createVNode("span", {
                      style: {"float":"right","color":"#0079fe"},
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (showPopup.value = true))
                    }, "舌苔拍照示例")
                  ]),
                  _createVNode("div", _hoisted_10, [
                    _hoisted_11,
                    _createVNode(_component_van_uploader, {
                      modelValue: getResourceImages.value,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (getResourceImages.value = $event)),
                      accept: "image/*",
                      "max-count": 3,
                      "max-size": 20 * 1024 * 1024,
                      "upload-text": "上传图片",
                      "image-fit": "cover",
                      "upload-icon": "plus",
                      onOversize: reourceImageOversize,
                      "after-read": uploadResourceImage,
                      deletable: !(formIsRead.value || FormIsDisabled.value),
                      "show-upload": !(formIsRead.value || FormIsDisabled.value),
                      readonly: formIsRead.value || FormIsDisabled.value
                    }, null, 8, ["modelValue", "deletable", "show-upload", "readonly"])
                  ])
                ]),
                _createVNode("div", _hoisted_12, [
                  _hoisted_13,
                  _createVNode("div", _hoisted_14, [
                    _createVNode(_component_van_field, {
                      modelValue: data.otherInfo,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (data.otherInfo = $event)),
                      autosize: { maxHeight: 250, minHeight: 70 },
                      type: "textarea",
                      maxlength: "1000",
                      placeholder: "您可以在这里填写更多身体状况的补充，如近期饮食、情绪、活动等方面的情况，便于专家准确判断并给出相应方案。",
                      "show-word-limit": ""
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                (!(formIsRead.value || FormIsDisabled.value))
                  ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                      _createVNode(_component_van_divider),
                      _createVNode(_component_van_row, null, {
                        default: _withId(() => [
                          _createVNode(_component_van_col, {
                            span: "20",
                            offset: "2"
                          }, {
                            default: _withId(() => [
                              _createVNode(_component_van_button, {
                                block: "",
                                round: "",
                                type: "primary",
                                color: "rgba(116, 83, 213, 1)",
                                onClick: save
                              }, {
                                default: _withId(() => [
                                  _hoisted_15
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ], 64))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["readonly"])
    ]),
    _createVNode(_component_van_popup, {
      onScroll: _unref(sheTaiPopupScrollCssStyle),
      "transition-appear": "",
      show: showPopup.value,
      "onUpdate:show": _cache[6] || (_cache[6] = ($event: any) => (showPopup.value = $event)),
      position: "bottom",
      style: { height: '70%', minHeight: '300px' }
    }, {
      default: _withId(() => [
        _createVNode("header", {
          class: ["popup-header", { 'popup-header--bottom': popupBoxShadom.value }]
        }, [
          _createVNode("div", _hoisted_16, [
            _createVNode(_component_van_icon, {
              name: "question",
              color: "#FE9400",
              size: "40px",
              style: {"float":"left"}
            }),
            _hoisted_17,
            _createVNode(_component_van_icon, {
              name: "cross",
              color: "#c8c9cc",
              size: "26px",
              style: {"float":"right","margin-top":"8px","margin-right":"10px"},
              onClick: _cache[4] || (_cache[4] = ($event: any) => (showPopup.value = false))
            })
          ])
        ], 2),
        _createVNode("article", _hoisted_18, [
          _createVNode("div", _hoisted_19, [
            _createVNode("div", _hoisted_20, [
              _createVNode(_component_van_image, {
                width: "80%",
                fit: "contain",
                src: _unref(SimpleSheTaiImage)
              }, null, 8, ["src"])
            ]),
            _hoisted_21,
            _createVNode("footer", _hoisted_22, [
              _createVNode(_component_van_divider),
              _createVNode(_component_van_row, null, {
                default: _withId(() => [
                  _createVNode(_component_van_col, {
                    span: "16",
                    offset: "4"
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_van_button, {
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (showPopup.value = false)),
                        type: "primary",
                        size: "small",
                        plain: "",
                        block: ""
                      }, {
                        default: _withId(() => [
                          _hoisted_23
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["onScroll", "show"])
  ]))
})
}

})